import { useContext, useEffect, useState } from "react"

import { useLocalSearchParams } from "expo-router"
import _ from "lodash"

import { AssetCollection, AssetHistory, Index } from "wealthmode-frontend/backend"
import { Box, HStack } from "wealthmode-frontend/gluestack/ui"
import { formatPercentage } from "wealthmode-frontend/util"

import { RawDataTable } from "@/components"
import { BackendContext } from "@/context"

type AssetHistoryYear = {
  year: number
  adjusted_return: string
}

export default function AssetHistoryPage() {
  const [loading, setLoading] = useState(true)
  const [collection, setCollection] = useState<Array<AssetHistoryYear>>([] as Array<AssetHistoryYear>)
  const backend = useContext(BackendContext)
  const { asset_id } = useLocalSearchParams<{ asset_id: string }>()

  useEffect(() => {
    async function go() {
      var data = backend.collection("data") as Index
      await data.fetch()

      var assets = data.link("assets")?.resolve() as AssetCollection
      var asset = assets.model(asset_id)
      await asset.fetch()

      var history = asset.link("history")?.resolve() as AssetHistory
      await history.fetch()

      const returns = history.attributes.yearly_adjusted_returns ?? {}

      function mapHistoryYear(year: number): AssetHistoryYear {
        return {
          year: year,
          adjusted_return: returns[year] ?? "",
        }
      }

      const years = _.sortBy(Object.keys(returns).map(Number), (year: number) => -year)
      const list: Array<AssetHistoryYear> = _.map(years, (year: number) => mapHistoryYear(year))

      setCollection(list)
      setLoading(false)
    }
    go()
  }, [backend, asset_id])

  return (
    <Box>
      <HStack>
        <Box className="flex-1">
          <RawDataTable
            title={"Asset History"}
            loading={loading}
            rows={collection}
            header={[
              { id: "year", title: "Year" },
              { id: "adjusted_return", title: "Adjusted Return" },
            ]}
            render={(model: AssetHistoryYear, field: string) => {
              switch (field) {
                case "year":
                  return model.year.toString()
                case "adjusted_return":
                  return formatPercentage(model.adjusted_return)
                default:
                  return ""
              }
            }}
          />
        </Box>
      </HStack>
    </Box>
  )
}
